import {ContentChildren, Directive, Input, OnDestroy, QueryList} from '@angular/core';
import {FormFieldComponent} from '../../../common/eparcours-components/components/mise-en-page/form-field/form-field.component';
import {Subscription} from 'rxjs';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {SelectEntitesComponent} from '../../../common/eparcours-components/components/select-entites/select-entites.component';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[formWithErrors]',
  exportAs: 'formWithErrors',
})
export class FormWithErrorsDirective implements OnDestroy {
  constructor() {}

  private saveButtonSubscription: Subscription;

  @Input() formWithErrors: UntypedFormGroup;

  _showErrors: boolean;

  @Input() set showErrorsIf(value: boolean | string) {
    const v = typeof value == 'string' ? value.toLowerCase() == 'true' : value;
    this._showErrors = v;
    this.toggleErrorsInAllFields(v);
  }

  @ContentChildren(SelectEntitesComponent, {descendants: true}) entiteItems: QueryList<SelectEntitesComponent>;
  @ContentChildren(FormFieldComponent, {descendants: true}) menuItems: QueryList<FormFieldComponent>;

  showErrors() {
    this.toggleErrorsInAllFields();
  }

  showError(aControl: UntypedFormControl, show: boolean = true) {
    this.showErrorEntiteComponent(aControl, show);
    this.showErrorFormField(aControl, show);
  }

  ngOnDestroy() {
    if (this.saveButtonSubscription != null) {
      this.saveButtonSubscription.unsubscribe();
      this.saveButtonSubscription = null;
    }
  }

  private toggleErrorsInAllFields(show: boolean = true) {
    if (this.entiteItems) {
      this.entiteItems.forEach(item => {
        show ? item.formField.showErrors() : item.formField.hideErrors();
      });
    }
    if (this.menuItems) {
      this.menuItems.forEach(item => {
        show ? item.showErrors() : item.hideErrors();
      });
    }
  }

  private showErrorEntiteComponent(aControl: UntypedFormControl, show: boolean) {
    if (this.entiteItems) {
      this.entiteItems.forEach(item => {
        if (item.formControl === aControl) {
          show ? item.formField.showErrors(false) : item.formField.hideErrors();
        }
      });
    }
  }

  private showErrorFormField(aControl: UntypedFormControl, show: boolean) {
    if (this.menuItems) {
      this.menuItems.forEach(item => {
        if (item.control === aControl) {
          show ? item.showErrors(false) : item.hideErrors();
        }
      });
    }
  }
}
